import { GeneralStyle } from '@website-builder/model/style/general-style';

export class GalleryConfig {
  masonry = false;
  enableFilterNavigation = false;
  filterStyle = 'uk-tab';
  showAllOption = true;
  allOptionText = 'All';
  alignment = 'uk-flex-center';
  margin = 'uk-margin-small-bottom';

  static normalize(styles: Partial<GalleryConfig>): GalleryConfig {
    const generalStyle: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new GalleryConfig();

    Object.assign(pureStyles, generalStyle);

    pureStyles.masonry = styles.masonry ?? pureStyles.masonry;
    pureStyles.enableFilterNavigation = styles.enableFilterNavigation ?? pureStyles.enableFilterNavigation;
    pureStyles.filterStyle = styles.filterStyle ?? pureStyles.filterStyle;
    pureStyles.showAllOption = styles.showAllOption ?? pureStyles.showAllOption;
    pureStyles.allOptionText = styles.allOptionText ?? pureStyles.allOptionText;
    pureStyles.alignment = styles.alignment ?? pureStyles.alignment;
    pureStyles.margin = styles.margin ?? pureStyles.margin;

    return pureStyles;
  }
}
